/**
 * Static WebP variants of the blog covers (written by
 * scripts/build-blog-catalog.mjs next to public/blog/<slug>/cover.jpg).
 * Served as plain files instead of /_next/image, which on OpenNext barely
 * compresses (121 KB for a phone-width cover vs 24 KB here) and sends no
 * cache header. Any other cover URL returns null and keeps next/image.
 */

// Keep in step with COVER_WIDTHS in scripts/build-blog-catalog.mjs.
const COVER_WIDTHS = [480, 768, 1200] as const;
const LOCAL_COVER = /^\/blog\/([a-z0-9-]+)\/cover\.jpg$/;

export function blogCoverSources(url: string): { src: string; srcSet: string } | null {
  const m = LOCAL_COVER.exec(url);
  if (!m) return null;
  const base = `/blog/${m[1]}/cover-`;
  return {
    src: `${base}768.webp`,
    srcSet: COVER_WIDTHS.map((w) => `${base}${w}.webp ${w}w`).join(", "),
  };
}
